var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.182 12c0-5.422 4.396-9.818 9.818-9.818S21.818 6.578 21.818 12 17.422 21.818 12 21.818 2.182 17.422 2.182 12zM12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm.972 14.555h-2.107c0-1.448.93-2.319 1.793-3.124.742-.694 1.432-1.34 1.432-2.264 0-1.063-.788-1.595-1.96-1.595-1.155 0-2.017.605-2.383 1.686L7.932 8.232c.697-1.796 2.383-2.713 4.252-2.713 2.035 0 4.014 1.21 4.014 3.52 0 1.51-.95 2.424-1.819 3.258-.732.704-1.407 1.352-1.407 2.258zm.33 2.877c0 .752-.623 1.375-1.374 1.375-.77 0-1.375-.623-1.375-1.375 0-.77.605-1.374 1.375-1.374.751 0 1.374.605 1.374 1.374z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.fc72110f7d9f7d2ba5a300891cd35693.svg";
export { ForwardRef as ReactComponent };